module.exports = __webpack_public_path__ + "assets/img/zhaoqing-35083d17.png";